'use client';

import { GroupField } from '@prismicio/client';
import {
  LoanUsesSliceCarouselPrimaryCardsItem,
  Simplify,
} from '../../../../../../prismicio-types';
import { useMounted, useScreenSize } from '@/hooks';
import { screenSizes } from '@/constants';
import { DesktopCards, MobileCards } from '.';

interface LoanUsesCarouselCardsProps {
  cards: GroupField<Simplify<LoanUsesSliceCarouselPrimaryCardsItem>>;
}

export const LoanUsesCarouselCards = ({
  cards,
}: LoanUsesCarouselCardsProps) => {
  const screenSize = useScreenSize();
  const isMounted = useMounted();

  if (!isMounted) return <></>;

  return screenSize.width <= screenSizes.desktop ? (
    <MobileCards cards={cards} />
  ) : (
    <DesktopCards cards={cards} />
  );
};
